<template>
  <HeroHeader />
  <section id="introduction">
    <img src="@/assets/images/logo-black.svg" alt="天聖閣" />
    <h3>
      <span>大切な人の旅立ちを</span>
      <span>厳かに格式高くお送りします。</span>
    </h3>
    <p>
      大切な人との出会いに感謝し会葬者おひとりお一人が最期のお別れを告げる聖なる空間。
      厳かに格式高くお送りし、想いを伝える心温まるセレモニーをお手伝いさせていただきます。
    </p>
  </section>
  <section id="home-contents">
    <div class="bigmenu">
      <div class="item">
        <div class="tx">
          <h3>天聖閣の特徴</h3>
          <h4>
            葬祭に必要なことすべてを
            <br />
            真心込めてお手伝い致します
          </h4>
          <p>
            1日1葬限定の貸切で、大切な御葬儀のお手伝いをいたします。
            <br />
            通夜・葬儀告別式から初七日法要まで、葬儀に必要なことは全てご利用いただけます。
          </p>
          <router-link class="contact-btn" to="/feature">
            特徴をみる
          </router-link>
        </div>
        <div class="imgwrap">
          <img src="@/assets/images/homeview/img1.jpg" alt="" />
        </div>
      </div>
      <div class="item">
        <div class="tx">
          <h3>御葬儀プラン</h3>
          <h4>
            規模やご予算、ご都合をお伺いし、
            <br />
            最適な御葬儀を提案いたします。
          </h4>
          <p>
            ご家族だけの葬儀からご会葬の方々が多い社葬まで、大小問わず要望に合わせた葬儀のご提案をいたします。安心してお任せいただけるよう、総額プランにてご案内させていただいております。
            <br />
            また、返礼品やお食事も、ご要望にあわせてご用意させていただきます。
          </p>
          <router-link class="contact-btn" to="/plan">御葬儀プラン</router-link>
        </div>
        <div class="imgwrap">
          <img src="@/assets/images/homeview/img2.jpg" alt="" />
        </div>
      </div>
    </div>
  </section>
  <section id="kaikan">
    <h2>会館のご案内</h2>
    <img class="map" src="@/assets/images/amakusa-map.svg" alt="" />
    <p>
      本渡、五和、苓北の3つの会館を展開しております。天草での御葬儀はお任せください。
      すべての会館にて家族葬や社葬など大小問わずお手伝いいたします。
    </p>
    <div class="kaikan-grid">
      <div class="item">
        <div class="imgwrap">
          <img src="@/assets/images/thumb-hondo.jpg" alt="天聖閣本渡斎場" />
        </div>
        <div class="tx">
          <h3>
            <img src="@/assets/images/logo01.svg" alt="天聖閣" />
            本渡斎場
          </h3>
          <div class="panorama">
            <img src="@/assets/images/ico-360.svg" alt="360°ビュー" />
            館内を360°パノラマ写真でご覧いただけます。
          </div>
          <router-link to="/information/hondo">詳細をみる</router-link>
        </div>
      </div>
      <div class="item">
        <div class="imgwrap">
          <img src="@/assets/images/thumb-itsuwa.jpg" alt="天聖閣五和斎場" />
        </div>
        <div class="tx">
          <h3>
            <img src="@/assets/images/logo01.svg" alt="天聖閣" />
            五和斎場
          </h3>
          <div class="panorama">
            <img src="@/assets/images/ico-360.svg" alt="360°ビュー" />
            館内を360°パノラマ写真でご覧いただけます。
          </div>
          <router-link to="/information/itsuwa">詳細をみる</router-link>
        </div>
      </div>
      <div class="item">
        <div class="imgwrap">
          <img src="@/assets/images/thumb-reihoku.jpg" alt="天聖閣苓北斎場" />
        </div>
        <div class="tx">
          <h3>
            <img src="@/assets/images/logo01.svg" alt="天聖閣" />
            苓北斎場
          </h3>
          <div class="panorama">
            <img src="@/assets/images/ico-360.svg" alt="360°ビュー" />
            館内を360°パノラマ写真でご覧いただけます。
          </div>
          <router-link to="/information/reihoku">詳細をみる</router-link>
        </div>
      </div>
    </div>
  </section>
  <ContactSection></ContactSection>
  <Footer></Footer>
</template>

<script>
import Footer from "@/components/PartsFooter.vue";
import HeroHeader from "@/components/PartsHeroHeader.vue";
import ContactSection from "@/components/PartsContact.vue";
export default {
  name: "HomeView",
  components: {
    HeroHeader,
    ContactSection,
    Footer,
  },
};
</script>
<style lang="scss" scoped>
#introduction {
  padding: 80px $h-gap;
  background: linear-gradient(to left, transparent, white, transparent),
    url(@/assets/images/bg-flower.jpg);
  background-position: center;
  background-size: cover;
  & > img {
    width: 30vw;
    max-width: 200px;
    min-width: 120px;
    margin: 0 auto;
    display: block;
  }
  h3 {
    font-size: 2rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
    text-align: center;
    line-height: 1.5;
    @include tb {
      font-size: 1.5rem;
    }
    span {
      display: inline-block;
    }
  }
  p {
    max-width: 720px;
    margin: 0 auto;
    line-height: 2;
  }
}
#home-contents {
  background-color: $color-bg1;
  padding: 80px $h-gap;
  .bigmenu {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 80px;

    .item {
      background-color: white;
      @include dogear(2rem);
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      @include tb {
        grid-template-columns: 1fr;
        .tx {
          order: 1;
        }
        .imgwrap {
          order: -1;
        }
      }
      &:nth-child(even) {
        @include dogear-rev(2rem);
        @include tb {
          @include dogear(2rem);
        }
        .tx {
          order: 1;
        }
        .imgwrap {
          order: -1;
        }
      }
      .tx {
        padding: 4rem;

        @include tb {
          padding: 1rem;
        }
        h3 {
          color: white;
          background-color: $color-hondo;
          display: inline-block;
          padding: 0.5rem 1rem;
          font-size: 1.5rem;
          margin-bottom: 2rem;

          @include tb {
            font-size: 1rem;
            margin-bottom: 1.5rem;
          }
        }
        h4 {
          font-size: 2rem;
          line-height: 1.5;
          position: relative;
          padding-bottom: 2rem;
          margin-bottom: 2rem;
          @include tb {
            font-size: 1.25rem;
            margin-bottom: 1rem;
          }
          &::after {
            @include pseudo;
            height: 1px;
            width: 8rem;
            bottom: 0;
            left: 0;
          }
        }
        p {
          line-height: 2;
          margin-bottom: 2rem;
          @include tb {
            font-size: 0.875rem;
          }
        }
        a {
          @include contact-btn;
          display: block;
        }
      }
      .imgwrap {
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          @include tb {
            aspect-ratio: 16/9;
          }
        }
      }
    }
  }
}
#kaikan {
  padding: 80px $h-gap;
  background-color: $color-bg1;
  h2 {
    text-align: center;
    position: relative;
    font-size: 2rem;
    padding-bottom: 2rem;
    margin-bottom: 2rem;
    @include tb {
      font-size: 1.5rem;
    }
    &::after {
      @include pseudo;
      width: 6rem;
      height: 1px;
      bottom: 0;
      left: calc(50% - 3rem);
    }
  }
  p {
    font-size: 1.5rem;
    line-height: 2;
    max-width: 960px;
    text-align: center;
    margin: 0 auto;
    margin-top: 2rem;
    @include tb {
      font-size: 1rem;
      text-align: left;
    }
  }
  .map {
    max-width: 560px;
    min-width: 320px;
    width: 50vw;
    margin: 0 auto;
    display: block;
  }
  .kaikan-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: clamp(16px, 5vw, 80px);
    margin: 0 auto;
    margin-top: 40px;
    max-width: $maxwidth;
    @include tb {
      grid-template-columns: 1fr;
    }

    .item {
      background-color: white;
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 0;
      @include tb {
        grid-template-columns: 1fr 2fr;
      }
      .imgwrap {
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          @include tb {
            aspect-ratio: 16/9;
          }
        }
      }
      .tx {
        padding: 1rem;
        h3 {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          width: 100%;
          margin-bottom: 1rem;
          @include tb {
            font-size: 1rem;
          }

          img {
            width: auto;
            height: 2.5rem;
            flex-grow: 0;
            margin-right: 1rem;
            @include tb {
              height: 2rem;
            }
          }
        }
        .panorama {
          background-color: #ceecff;
          display: flex;
          padding: 0.5rem;
          border-radius: 0.5em;
          align-items: center;
          margin-bottom: 1rem;
          font-size: 0.875rem;
          line-height: 1.5;
          @include tb {
            padding: 0.25rem 0.5rem;
            font-size: 0.6rem;
          }
          img {
            width: 60px;
            margin-right: 1rem;
            @include tb {
              width: 45px;
            }
          }
        }
        a {
          display: block;
          text-align: center;
          color: $blue;
          border: 1px solid $blue;
          font-size: 1.25rem;
          padding: 0.5em 1em;
          @include tb {
            font-size: 1rem;
          }
        }
      }
    }
  }
}
</style>
